import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";

const MyConsigneeComponent = ({
  field: { name },
  form: { setFieldValue },
  billingPartyId,
  setConsigneeArray,
  consigneeArray,
  ...props
}) => {
  const [consignee, setConsignee] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [Txt, setTxt] =useState("");

  useEffect(() => {
    setisloading(true)

    const customerNo = localStorage.getItem('customerNumber')

    if (customerNo == 1183 && (billingPartyId != null && billingPartyId != undefined)) {
      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/mappings/consignee_billing_party_branch?billingPartyId=${billingPartyId}`,
        // payload: { searchTerm: searchTerm },
      }).then((result) => {
        console.log("Result : ", result.data.resultSet);
        setConsigneeArray(result.data.resultSet);
        setisloading(false);
      });
    } else if (props?.dontLoadInit == false) {
      if (props?.setData) {
        let temp = {};
        temp.ConsigneeId = props?.setData?.id;
        temp.consigneeName = props?.setData?.name;
        temp.consigneeCode = props?.setData?.consigneeCode;
        temp.raw = props.setData;

        setConsignee([temp])
      }
      setisloading(false);
    } else if (props.mode == "edit") {
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/consigneeMaster`,
        // payload: { searchTerm: searchTerm },
      }).then((result) => {
        console.log("Result : ", result.data.resultSet);
        setConsignee(result.data.resultSet);
        setisloading(false);
      });
    } else {
      setisloading(false);
    }
  }, []);

  let handleSearch = (e, data) => {
    // if (data.searchQuery) {
      setisloading(true);
      let searchTerm = data.searchQuery;
      setTxt(data.searchQuery);
      setFieldValue(name, data.value);
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/consigneeMaster`,
        payload: { searchTerm: searchTerm },
      }).then((result) => {
        console.log("Result : ", result.data.resultSet);
        setConsignee(result.data.resultSet);
        setConsigneeArray && setConsigneeArray(result.data.resultSet);
        setisloading(false);
      });
    // }
  };

  let handleChange = (value, data) => {
    if (data.value) {
      setFieldValue(name, data.value);
      console.log("ccc", props.deliverTo);
      let op = data.options;
      op.map((item, o) => {
        if (item.raw.consigneeCode == data.value) {
          setFieldValue(props.cename, item.raw.consigneeName);
          if (props?.consigneeIDName) {
            setFieldValue(props.consigneeIDName, item.raw.consigneeId);
          }
        }
      });
      let filteredoptions = consignee.filter(
        (item) => item.consigneeCode == data.value
      );

      let filteredOptions = consigneeArray.filter(item => {

        return item.consigneeCode == data.value
      });


      console.log("Match Array", filteredOptions, data.value)
      if (filteredoptions.length != 0) {

        setFieldValue(props.address, filteredoptions[0].address);
        setFieldValue(props.gst, filteredoptions[0].gstNumber);
        setFieldValue(props.deliverTo, filteredoptions[0].address);
        props.onChangeExtra && props.onChangeExtra(filteredoptions[0]);
      } else {
        setFieldValue(props.address, filteredOptions[0].address);
        setFieldValue(props.gst, filteredOptions[0].gstNumber);
        setFieldValue(props.deliverTo, filteredOptions[0].address);
      }


    } else {
      setFieldValue(props.address, "");
      setFieldValue(props.gst, "");
      setFieldValue(props.deliverTo, "")
      setFieldValue(name, "");
      setFieldValue(props.cename, "");
    }
  };

  let consigneeNames = [];
  if (localStorage.getItem('customerNumber') == 1183 && consigneeArray) {
    const filterdBillers = consignee.filter(obj => {return obj.consigneeName.toLowerCase().startsWith(Txt)})
    console.log("filterdBillers",filterdBillers);
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.ConsigneeId;
      temp.text = `${object.consigneeName} (${object.consigneeCode})`;
      temp.value = object.consigneeCode;
      temp.raw = { ...object };
      return (consigneeNames[index] = temp);
    });

  } else {
    if (consignee.length > 0) {
      const filterdBillers = consignee.filter(obj => {return obj.consigneeName.toLowerCase().startsWith(Txt)})
    console.log("filterdBillers",filterdBillers);
    filterdBillers.map((object, index) => {
        let temp = {};
        temp.key = object.consigneeId;
        temp.text = `${object.consigneeName} (${object.consigneeCode})`;
        temp.value = object.consigneeCode;
        temp.raw = { ...object };
        return (consigneeNames[index] = temp);
      });
    }
  }

  let OptionsList = consigneeNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);

  return (
    <>
      <Dropdown
        selection
        search
        clearable
        loading={isloading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={OptionsList}
        onSearchChange={localStorage.getItem('customerNumber') != 1183 ? handleSearch : false}
        {...props}
      />
    </>
  );
};

export default MyConsigneeComponent;
